module.exports = __webpack_public_path__ + "res/materialdesignicons-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/lumx/fonts/materialdesignicons-webfont.ttf?v=1.9.32
// module id = 112
// module chunks = 1